import React from 'react';
import DeviceActions from '#component/device/overview/actions';
import DeviceInfo from '#component/device/overview/info';
import DateRange from '#component/general/date-range';
import DateRangeControls from '#component/general/date-range/date-range-controls';
import {
  MobileHeader,
  DeviceInfoGridItem,
  DeviceNameContainer,
  DeviceName,
  DateRangeGridItem
} from '#component/device/overview/styles';

function Header(props) {
  const {
    device,
    account,
    metrics,
    isWidthDownSm,
    isInRange,
    minMaxDate,
    rangeStart,
    rangeEnd,
    setDateRange,
    openEndDateDialog,
    setOpenEndDateDialog
  } = props;

  const eventOff = device.power && device.power.identifier === 'off';
  const isAnyMetric = Object.values(metrics).some(v => v.length);

  return (
    <MobileHeader container spacing={2} id="overviewHeader">
      <DeviceInfoGridItem item xs={12} sm={5} md={6}>
        <DeviceNameContainer>
          <DeviceActions
            isInRange={isInRange}
            device={device}
            account={account}
            isAnyMetric={isAnyMetric}
            dateRange={[rangeStart, rangeEnd]}
          >
            <DeviceName
              variant="h5"
              gutterBottom
              off={eventOff}
            >
              {device.title || device.uid}
            </DeviceName>
          </DeviceActions>
        </DeviceNameContainer>
        {!eventOff && !isWidthDownSm &&
        <DeviceInfo
          device={device}
          account={account}
          // `lastMetric.youngest` livedata from the socket connection
          lastMetric={device?.lastMetric?.youngest || device?.lastMetric}
        />}
      </DeviceInfoGridItem>
      <DateRangeGridItem item xs={12} sm={7} md={6}>
        <DateRangeControls
          rangeStart={rangeStart.toISOString()}
          rangeEnd={rangeEnd.toISOString()}
          setDateRange={setDateRange}
          minDate={minMaxDate.minDate?.toISOString()}
          maxDate={new Date().toISOString()}
          isInRange={isInRange}
          totalMonthRange={3}
        />
        <DateRange
          rangeStart={rangeStart.toISOString()}
          rangeEnd={rangeEnd.toISOString()}
          setDateRange={setDateRange}
          minDate={minMaxDate.minDate?.toISOString()}
          maxDate={new Date().toISOString()}
          isInRange={isInRange}
          totalMonthRange={3}
          openEndDateDialog={openEndDateDialog}
          setOpenEndDateDialog={setOpenEndDateDialog}
        />
        <DateRangeControls
          rangeStart={rangeStart.toISOString()}
          rangeEnd={rangeEnd.toISOString()}
          setDateRange={setDateRange}
          minDate={minMaxDate.minDate?.toISOString()}
          maxDate={new Date().toISOString()}
          isInRange={isInRange}
          totalMonthRange={3}
          mode="update"
        />
      </DateRangeGridItem>
    </MobileHeader>
  );
}

export default Header;
